export const getImageDimensions = src => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () =>
      resolve({
        originalHeight: img.naturalHeight,
        originalWidth: img.naturalWidth
      });
    img.onerror = reject;
    img.src = src;
  });
};
